import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { ConfirmationDeleteModalComponent } from 'src/app/shared-components/confirmation-delete-modal/confirmation-delete-modal.component';
import { PaginationListResponse } from 'src/app/_models/pagination-list-response';
import { AuthService } from 'src/app/_services/auth.service';
import { GetOfertasActivasDocenteResponse } from '../responses/get-ofertas-activas-docente-response';
import { DocenteService } from '../services/docente.service';

@Component({
  selector: 'app-doc-ofertas-activas',
  templateUrl: './doc-ofertas-activas.component.html',
  styleUrls: ['./doc-ofertas-activas.component.css']
})
export class DocOfertasActivasComponent implements OnInit{
  public breadcrumb : any;

  currentUser : any

  response : PaginationListResponse<GetOfertasActivasDocenteResponse>;
  currentPage : number=1;

  constructor(private docenteService : DocenteService,
              private router : Router,
              private toastr : ToastrService,
              private authService : AuthService,
              private modalService : NgbModal) {
  }

  async ngOnInit() 
  {
    this.currentUser = this.authService.getProf();
    if(this.currentUser && this.currentUser.idUsuario>0)
    {
      await this.getListOfertasActivas();

      this.breadcrumb = {
        'mainlabel': 'Ofertas Publicadas'
        };
    }
  }

  async getListOfertasActivas() : Promise<boolean>
  {
    try 
    {
      const result = await firstValueFrom(this.docenteService.getOfertasActivas(this.currentUser.idUsuario));
      if(result && result.data && result.totalPages>0 &&result.totalRows>0)
      {
        this.response = result;
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  openDetailOffer(idOferta:number) {
    if(idOferta>0)
    {
      this.router.navigate(['docente/oferta/detalles'], {
        queryParams: { idOferta: JSON.stringify(idOferta) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toastr.error('Error al abrir detalles','error');
  }

  seePostulantes(oferta:GetOfertasActivasDocenteResponse)
  {
    if(oferta && oferta.idOferta>0 && oferta.numeroPostulantes > 0 && oferta.listaPostulantes.length>0)
    {
      this.router.navigate(['docente/oferta/postulados'], {
        queryParams: { detallesOferta: JSON.stringify(oferta) },
        skipLocationChange: true //skip location para ocultar el json de la URL
      });
    }
    else
      this.toastr.error('No se ha podido recuperar información relacionada a los postulantes de la oferta de trabajo porque la lista puede estar vacía.','Error');
  }

  async openModalConfirmation(item)
  {
    const modalRef = this.modalService.open(ConfirmationDeleteModalComponent,{ windowClass: 'animated fadeInUp',keyboard:false,backdrop: false });
    modalRef.componentInstance.title = 'Confirmación';
    modalRef.componentInstance.message1 = '¿Estas seguro de cancelar la oferta?';
    modalRef.componentInstance.message2 = 'Al cancelar la oferta, no se podrá revertir y tendrás que repetir el proceso de revisión.';
    modalRef.result.then(async (result) => {
      if (result === 'accept') {
        // El usuario ha aceptado el modal
          const result = await this.deleteOfertaActiva(item.idOferta);
          if(!result)
          {
            this.toastr.error('No fue posible eliminar la oferta. Inténtalo de nuevo.','Error');
            return;
          }
          item.deleted=true;
          this.toastr.success('Se ha cancelado la publicación de la oferta de trabajo.','Hecho');
      }
    }, (reason) => {
      // El usuario ha cerrado el modal sin hacer clic en ningún botón
    });
  }

  async deleteOfertaActiva(idOferta:number) : Promise<boolean>
  {
    if(idOferta)
    {
      try 
      {
        const data = await firstValueFrom(this.docenteService.deleteOfertaActiva(idOferta));
        if(!data.success)
        {
          this.toastr.error('No fue posible cancelar la oferta. Inténtalo de nuevo','Error');
          return false;
        }
        return true;
      }
      catch (error) {
        this.toastr.error('No fue posible cancelar la oferta. Inténtalo de nuevo','Error');
        return false;
      }
    }
    return false;
  }

  pageChange(page: any) {
    this.docenteService
      .getOfertasActivasByPage(this.currentUser.idUsuario,(page - 1) * this.response.pageSize)
      .subscribe((response) => {
        this.response = response;
      });
  }


}
